import { Component, ChangeDetectionStrategy, signal, computed } from '@angular/core';

@Component({
  selector: 'mib-tooltip',
  template: `{{ message() }}`,
  host: {
    '[class]': 'classes()',
    '[style.pointer-events]': '"none"',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MibTooltipComponent {
  readonly message = signal<string>('');

  readonly classes = computed(() => {
    const baseClasses = 'bg-gray-900 text-white text-sm px-2 py-1 rounded shadow-lg w-max max-w-64 block';
    const animationClasses = 'opacity-0 transition-opacity duration-200';
    return `${baseClasses} ${animationClasses}`;
  });

  show(message: string): void {
    this.message.set(message);
  }
}
